/**
 * Google Analytics 4 helper for SPA
 * ID: G-WHZW7ZWWWY - hard-coded per user request, also reads VITE_GA_ID if set
 */

export const GA_ID = (import.meta.env.VITE_GA_ID as string) || 'G-WHZW7ZWWWY'

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void
    dataLayer?: unknown[]
  }
}

export function gtagPageview(path: string) {
  if (typeof window === 'undefined' || !window.gtag) return
  // SPA page_view - GA4 expects page_path + page_location
  window.gtag('config', GA_ID, {
    page_path: path,
    page_location: window.location.href,
  })
  // also send explicit page_view event for more reliable SPA tracking
  window.gtag('event', 'page_view', {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
  })
}

export function gtagEvent(name: string, params?: Record<string, unknown>) {
  if (typeof window === 'undefined' || !window.gtag) return
  window.gtag('event', name, params)
}
